var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',_vm._b({class:`${_vm.color}-icon`,attrs:{"src":require(`@/assets/images/${_vm.img}`),"contain":""}},'v-img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }